import classNames from 'classnames';
import type { FC, ReactNode } from 'react';

interface StickyControlsContainerProps {
  children: ReactNode;
  className?: string;
}

const StickyControlsContainer: FC<StickyControlsContainerProps> = ({
  children,
  className,
}) => (
  <div
    className={classNames(
      'sticky z-10 bottom-0 bg-white border-t border-t-primary-100 py-6 flex gap-2 justify-center items-center',
      className,
    )}
  >
    {children}
  </div>
);

export default StickyControlsContainer;
